import { FC, useEffect } from "react";
import "./style.scss";
import GoBack from "../../../assets/GoBackApp.svg";
import Chat from "../../../assets/ChatColored.svg";
import AuthChat from "../../../assets/AuthChat.svg";
import AuthPhone from "../../../assets/AuthPhone.svg";
import WhatsAppIcon from "../../../assets/WhatsApp.svg";
import { useTranslation } from "react-i18next";
import { getTelUrl, getWhatsAppUrl } from "static/contacts";
import { useNavigate } from "react-router-dom";
import { useStore } from "zustand";
import { generalSocketStore } from "services/general.socket";
import { PATH_LIST } from "shared/lib/react-router";
import NotificationIcon from "../components/notification-icon";

export type BtnPropsType = {
  onClick: () => void;
  img: string;
  name: string;
  notificationType?: string;
};

export const AuthChatBtn: FC<BtnPropsType> = ({
  onClick,
  img,
  name,
  notificationType,
}) => (
  <button onClick={onClick} className="auth-chat-btn">
    <img src={img} alt={name} />
    <p>{name}</p>

    {notificationType && <NotificationIcon type={notificationType} />}
  </button>
);

export const ChatPage = () => {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();
  const { checkChat } = useStore(generalSocketStore);

  useEffect(() => {
    checkChat();
  }, []);

  return (
    <div className="chat-page">
      <div className="chat-page-header">
        <img
          className="go-back-portfolio"
          onClick={() => {
            navigate(PATH_LIST.home);
          }}
          src={GoBack}
          alt="Go Back"
        />
        <p>{t("support")}</p>
      </div>

      <div className="chat-page-main">
        <div className="chat-page-main-top">
          <img src={Chat} alt="chat" />
          <p>{t("happyToHelp")}</p>
          <span>{t("selectContactMethod")}</span>
        </div>
        <div className="chat-page-main-bottom">
          <AuthChatBtn
            onClick={() => navigate(PATH_LIST.support)}
            img={AuthChat}
            name={t("chat")}
            notificationType="support"
          />

          <AuthChatBtn
            onClick={() => (window.location.href = getTelUrl())}
            img={AuthPhone}
            name={t("call")}
          />

          <AuthChatBtn
            onClick={() => window.open(getWhatsAppUrl(), "_blank")}
            img={WhatsAppIcon}
            name="WhatsApp"
          />
        </div>
      </div>
    </div>
  );
};

// todo
// const previousPathRef = useRef<string | null>(null);
// const [currentPath, setCurrentPath] = useState(location.pathname);

// useEffect(() => {
//   if (currentPath !== location.pathname) {
//     previousPathRef.current = currentPath;
//     setCurrentPath(location.pathname);
//   }
//   console.log("====================================");
//   console.log(currentPath);
//   console.log("====================================");
// }, [location.pathname, currentPath]);
// if (
//   previousPathRef.current &&
//   (previousPathRef.current.includes("chat") ||
//     previousPathRef.current.includes("auth"))
// ) {
//   navigate(PATH_LIST.home);
// } else {
//   navigate(-1);
// }
